import { homeService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import { useCategories, useDropTypes, useFloors } from "@mibuildweb/hooks";
import {
  ICategoryFloorDropTypesPayload,
  IMaxFloorPayload,
} from "../../CustomerPricingDetails/CustomerPricingDetails.types";

export const useCustomerFloorsDropsTabViewModel = () => {
  const stateManager = useComponentState();

  const { floors, getFloors, isLoading: isFloorsLoading } = useFloors();

  const {
    categories,
    categoryDrops,
    getCategories,
    getCategoryDrops,
    isLoading: isCategoriesLoading,
  } = useCategories();

  const {
    dropTypes,
    getDropTypes,
    isLoading: isDropTypesLoading,
  } = useDropTypes();

  const saveAccountConfig = async (data: IMaxFloorPayload) => {
    return stateManager.run(async () => {
      const response = await homeService.accountConfigs.update({
        id: data.accountId,
        data: {
          maxFloorId: data.maxFloorId,
        },
        toastMessageConfig: {
          success: { text: "Successfully saved floor configuration." },
        },
      });
      return response;
    });
  };

  const getCategoryFloorDropTypes = async (accountId: string) => {
    return stateManager.run(async () => {
      const response = await homeService.accountConfigs.floorDropTypes.getAll({
        id: accountId,
      });
      return response;
    });
  };

  const saveCategoryFloorDropTypes = async (
    accountId: string,
    data: ICategoryFloorDropTypesPayload[]
  ) => {
    return stateManager.run(async () => {
      const response = await homeService.accountConfigs.floorDropTypes.update({
        id: accountId,
        data: data.map(({ categoryId, floorId, dropTypeId }) => ({
          categoryId,
          floorId,
          dropTypeId,
        })),
        toastMessageConfig: {
          success: { text: "Successfully saved floor drop types." },
        },
      });
      return response;
    });
  };

  return {
    floors,
    categories,
    categoryDrops,
    dropTypes,
    getFloors,
    getCategories,
    getCategoryDrops,
    getDropTypes,
    saveAccountConfig,
    getCategoryFloorDropTypes,
    saveCategoryFloorDropTypes,
    isLoading:
      isFloorsLoading ||
      isCategoriesLoading ||
      isDropTypesLoading ||
      stateManager.isBusy(),
  };
};
